import { writable } from 'svelte/store';

export const menu_on = writable("about");
